// extracted by mini-css-extract-plugin
module.exports = {"switch":"_9e1425b4d3--switch--zSOGs","indicator":"_9e1425b4d3--indicator--MoK0B","label":"_9e1425b4d3--label--uLnzC"};